<template>
  <div class="edit_frame">
    <common_edit :multiple="multiple"></common_edit>
    <template v-if="module.textType === 'positionInfo'">
        <!-- 选中挂件是职位信息才展示该配置 -->
        <div class="title">
            职位信息
        </div>
        <div class="position">
            <el-checkbox-group
                v-model="module.positionInfoList"
                direction="horizontal"
                @change="handlePositionInfoChange"
            >
                <el-checkbox v-for="item in positionList" :key="item.label" :label="item.label" >{{item.label}}</el-checkbox>
            </el-checkbox-group>
        </div>
    </template>
    <div class="title">
        样式
    </div>
    <div class="text-content">
        <template v-if="module.isEditing">
          <el-tooltip class="item" effect="dark" content="颜色" placement="top">
            <my_color ref="colorPicker" v-if="!isPlainStroke" @change="on_color_change" :color.sync="color" />
          </el-tooltip>
        </template>
        <template v-else>
          <el-tooltip class="item" effect="dark" content="颜色" placement="top">
            <my_color ref="colorPicker" v-if="!isPlainStroke" :color.sync="module.style.color" @change="on_color_change" />
          </el-tooltip>
          
        </template>
        <my_text_align
        class="bottom flexbox sel_align"
        :value.sync="module.style['text-align']"
        @changeTextAlign="on_text_align_change"
        />
        <my_font_style
        class="flexbox sel_style"
        @changeFontWeight="on_font_weight_change"
        @changeFontStyle="on_font_style_change"
        @changeTextDecoration="on_text_decoration_change"
        @changeWritingMode="on_writing_mode_change"
        />
    </div>
    <div class="title">
        文字
    </div>
    <section class=" text-content">
      <div class="flexbox sel_powerover">
        <template v-if="module.isEditing">
            <my_font_family
            class="sel_family"
            title="字体"
            size="small"
            :value="font_family"
            @change="on_font_family_change"
            />
        </template>
        <template v-else>
            <my_font_family
            class="sel_family"
            title="字体"
            size="small"
            :value.sync="module.style['font-family']"
            @change="on_font_family_change"
            />
        </template>
        <template v-if="module.isEditing">
          <my_font_size_new title="字号" :value.sync="font_size" @change="on_change_font_size" />
        </template>
        <template v-else>
          <my_font_size_new title="字号" :value.sync="module.style['font-size']" @change="on_change_font_size" />
        </template>
      </div>
      <!-- <my_opacity class="sel_opacity" :value.sync="module.style.opacity" /> -->
    </section>
  </div>
</template>

<script type="text/javascript">
import { richTextHelper } from '@/base/richTextHelper'
import common_edit from '../../module_edit/common_edit.vue'
import my_text_align from '../../my_text_align'
import my_font_style from '../../my_font_style'
import my_font_family from '../../my_font_family'
import my_font_size_new from '../../my_font_size_new'
import my_color from '../../my_color'
export default {
  name: 'BasicTextEdit',
  components: {
    common_edit,
    my_text_align,
    my_font_style,
    my_font_family,
    my_font_size_new,
    my_color
  },
  data() {
    return {
      isShadowStrokeSize: false,
      isShadowH: false,
      isShadowV: false,
      isShadowB: false,
      isLetter: false,
      isLine: false,
      font_family: '',
      font_size: 14,
      line_height: 14,
      color: '',
      background_color: '',
      activeCollapseItem: 0,
      module: null,

      isBorderWidth: false,
      isShadowX: false,
      isShadowY: false,
      isShadowBlur: false,
      checkList: [],
      disabledData: ['职位名称', '工作职责', '任职资格'],
      textList: {
        '招聘类别': '<img src="/img/poster/icon1.png"/>默认类别&nbsp; &nbsp; &nbsp;',
        '工作性质': '<img src="/img/poster/icon2.png"/>全职&nbsp; &nbsp; &nbsp;',
        '工作地点': '<img src="/img/poster/icon3.png"/>全国'
      }
    }
  },
  props: {
    // 是否处于多选状态
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    positionList() {
      return this.$store.state.options.positionInfo
    },
    select_module() {
      return this.$store.state.widgets.select_module
    },
    need3d() {
      return this.module.properties && [1, 2, 3].includes(this.module.properties.wordArtType)
    },
    needStroke() {
      return this.module.properties && [2].includes(this.module.properties.wordArtType)
    },
    isPlainStroke() {
      return this.module.artType === 'plainStroke' || this.module.type === 'stroke'
    },
    widgets() {
      return this.templet.get_widgets()
    }
  },
  methods: {
    handlePositionInfoChange(val) {
      var getSelectData = this.positionList.filter(item => { return val.includes(item.label) })
      var selectText = ''
      var content = ''
      //  选择职位属性排序
      getSelectData.sort(function (a, b) {
        return a.sort - b.sort
      })
      var selectLabel = getSelectData.map(item => item.label)
      console.log(val,selectLabel,'getSelectData')
      this.module.positionInfoList = JSON.parse(JSON.stringify(selectLabel))
      if (getSelectData.length) {
        selectText = getSelectData.map(item => item.text)
        this.module.text = selectText.join(' | ')
      } 
      selectLabel.forEach(text => {
        if (this.textList[text]) content = content + this.textList[text]
      })
      this.widgets.map(widgets => {
        if (widgets.textType === 'infoIcon') {
          if (content) {
            widgets.text = `<span style="font-size: 16px;">${content}</span>`
            widgets.style.height = 'auto'
          } else {
            widgets.text = ''
            widgets.style.height = 0
          }
        }
      })
    },
    on_color_change(val) {
      var that = this
      document.execCommand('styleWithCSS', null, true)
      if (this.module.isEditing) {
        richTextHelper.execCommand('forecolor', 0, val, () => {
          changeFontColor()
        })
      } else {
        this.select_text_widget(() => {
          document.execCommand('forecolor', 0, val)
          changeFontColor()
        })
      }
      function changeFontColor() {
        if (that.multiple) {
          that.select_module.forEach(item => {
            // 修复火狐浏览器的bug,font标签color=rgba格式的颜色不生效
            $(`#u${item.tid} .my-contenteditable font[color]`).removeAttr('color').css({
              color: val
            })
            item.style.color = val
            const html = $(`#u${item.tid} .my-contenteditable`).html()
            if (item.text !== html) {
              item.text = html
            }
          })
        } else {
          // 修复火狐浏览器的bug,font标签color=rgba格式的颜色不生效
          $(`#u${that.module.tid} .my-contenteditable font[color]`).removeAttr('color').css({
            color: val
          })
        }
      }
    },
    on_font_family_change(val) {
      // 动态插入字体文件
      this.font_family = val
      this.utils.insert_font_face(val)
      if (this.module.isEditing) {
        richTextHelper.execCommand('fontName', 0, val)
      } else {
        this.select_text_widget(() => {
          document.execCommand('fontName', 0, val)
        }, 'font-family')
      }
    },
    on_change_font_size(val) {
      // 这个判断是为了首次双击，初始化font_size，避免将字体变成14px
      if (this.module.isEditing && this.module.on_double_click > -1) {
        val = this.module.style['font-size']
        this.font_size = val
        --this.module.on_double_click
        return
      }
      const that = this
      const lineHeight = Math.floor(val * 1.3)
      if (this.module.isEditing) {
        // this.module.style['line-height'] = lineHeight
        richTextHelper.execCommand('fontSize', 0, 7, () => {
          changeFont()
        })
      } else {
        this.module.style['line-height'] = lineHeight
        this.select_text_widget(() => {
          document.execCommand('fontSize', 0, 7)
          changeFont()
        })
      }
      function changeFont() {
        const publicPart = module => {
          $(`#u${module.tid} .my-contenteditable font[size]`)
            .removeAttr('size')
            .css({
              fontSize: val + 'px'
            })
          $(`#u${module.tid} .my-contenteditable span, #u${module.tid} .my-contenteditable font`).each((_index, el) => {
            const fontSize = $(el)[0].style.fontSize || ''
            if (fontSize.length && !fontSize.endsWith('px')) {
              $(el)[0].style.fontSize = val + 'px'
            }
          })
        }
        if (that.multiple) {
          that.select_module.forEach(item => {
            publicPart(item)
            item.style['font-size'] = that.module.style['font-size']
            const html = $(`#u${item.tid} .my-contenteditable`).html()
            if (item.text !== html) {
              item.text = html
            }
          })
        } else {
          publicPart(that.module)
        }
      }
    },
    on_font_weight_change(val) {
      if (this.module.isEditing) {
        richTextHelper.execCommand('bold', 0, null)
      } else {
        this.select_text_widget(() => {
          document.execCommand('bold', 0, null)
        }, 'font-weight')
      }
      this.module.style['font-weight'] = val
    },
    on_font_style_change(val) {
      if (this.module.isEditing) {
        richTextHelper.execCommand('italic', 0, null)
      } else {
        this.select_text_widget(() => {
          document.execCommand('italic', 0, null)
        }, 'font-style')
      }
      this.module.style['font-style'] = val
    },
    on_text_decoration_change(type) {
      const cmd = type === 'underline' ? 'underline' : 'strikeThrough'
      if (this.module.isEditing) {
        richTextHelper.execCommand(cmd, false, '')
      } else {
        this.select_text_widget(() => {
          document.execCommand(cmd, false, '')
        }, cmd)
      }
      if (this.module.style['text-decoration'] === 'underline') {
        this.module.style['text-decoration'] = 'none'
      } else {
        this.module.style['text-decoration'] = 'underline'
      }
    },
    on_writing_mode_change() {
      // 全局的
      const shuiping = 'horizontal-tb'
      const shuzhi = 'vertical-lr'
      const publicPart = (module, mode) => {
        module.style['writing-mode'] = mode
        let _height = module.style['height']
        _height = _height === 'auto' ? $('#u' + module.tid + ' .my-contenteditable')[0].offsetHeight : _height
        module.autoFixLayoutSize = false
        module.style['height'] = module.style['width']
        module.style['width'] = _height
        this.$nextTick(() => {
          module.autoFixLayoutSize = true
        })
      }
      if (this.multiple) {
        const res = this.judge_text_orientation()
        if (res.type === 1) {
          // 有横排有竖排
          const mode = shuiping
          this.select_module.forEach(item => {
            if (item.style['writing-mode'] === shuzhi) {
              publicPart(item, mode)
            }
          })
        } else {
          // 都横排或者都竖排
          const mode = this.select_module[0].style['writing-mode'] === shuzhi ? shuiping : shuzhi
          this.select_module.forEach(item => {
            publicPart(item, mode)
          })
        }
      } else {
        const mode = this.module.style['writing-mode'] === shuzhi ? shuiping : shuzhi
        publicPart(this.module, mode)
      }
    },
    on_text_align_change(align) {
      const publicPart = module => {
        $('#u' + module.tid + ' .my-contenteditable div').each((index, el) => {
          if (el.style['text-align'] && el.style['text-align'] !== 'inherit') {
            el.style['text-align'] = 'inherit'
          }
        })
      }
      if (this.multiple) {
        this.select_module.forEach(item => {
          publicPart(item)
          item.style['text-align'] = align.value
        })
      } else {
        publicPart(this.module)
      }
    },
    /**
     * @param {*} command 需要执行的命令
     * @param {*} variable 传入修改的变量
     */
    select_text_widget(command, variable) {
      const publicPart = module => {
        $('#u' + module.tid + ' .my-contenteditable').attr('contentEditable', true)
        const node = document.querySelector('#u' + module.tid + ' .my-contenteditable')
        const range = document.createRange()
        range.selectNodeContents(node)
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        command && command()
        $('#u' + module.tid + ' .my-contenteditable').attr('contentEditable', false)
        // 取消文字选中状态
        selection.empty()
      }
      if (this.multiple) {
        const arr = ['font-weight', 'font-style', 'underline', 'strikeThrough']
        let res = null
        if (variable === 'font-weight') {
          res = this.judge_font_weight()
        } else if (variable === 'font-style') {
          res = this.judge_font_style()
        } else if (variable === 'underline') {
          res = this.judge_text_decoration_line()
        } else if (variable === 'strikeThrough') {
          res = this.judge_text_decoration_line_through()
        }
        this.select_module.forEach(item => {
          if (arr.includes(variable)) {
            if (res?.type === 1) {
              // 有不相同的地方
              if (res.normalArr.includes(item.tid)) {
                publicPart(item)
              }
            } else {
              // 都相同
              publicPart(item)
            }
          } else {
            publicPart(item)
          }
          // 修改module的值
          if (variable === 'font-family') {
            item.style['font-family'] = this.module.style['font-family']
            const html = $(`#u${item.tid} .my-contenteditable`).html()
            if (item.text !== html) {
              item.text = html
            }
          } else if (arr.includes(variable)) {
            const html = $(`#u${item.tid} .my-contenteditable`).html()
            if (item.text !== html) {
              item.text = html
            }
          }
        })
      } else {
        publicPart(this.module)
      }
    },
    // 判断多选module里面的字重情况
    judge_font_weight() {
      // 两种情况，有粗有细（只执行细的），都粗或者都细（都执行）
      const boldArr = []
      const normalArr = []
      let type = null
      this.select_module.forEach(item => {
        const html = $(`#u${item.tid} .my-contenteditable`).html()
        if (html.includes('font-weight: bold;')) {
          boldArr.push(item.tid)
        } else if (html.includes('font-weight: normal;')) {
          normalArr.push(item.tid)
        } else if (item.style['font-weight'] === 'bold') {
          boldArr.push(item.tid)
        } else {
          normalArr.push(item.tid)
        }
      })
      if (boldArr.length > 0 && normalArr.length > 0) {
        type = 1
      } else {
        type = 2
      }
      return {
        type, // 1:有粗有细，2：都粗或者都细
        normalArr
      }
    },
    // 判断多选module里面的字斜情况
    judge_font_style() {
      // 两种情况，有斜有正（只执行正的），都斜或者都正（都执行）
      const italicArr = []
      const normalArr = []
      let type = null
      this.select_module.forEach(item => {
        const html = $(`#u${item.tid} .my-contenteditable`).html()
        if (html.includes('font-style: italic;')) {
          italicArr.push(item.tid)
        } else {
          normalArr.push(item.tid)
        }
      })
      if (italicArr.length > 0 && normalArr.length > 0) {
        type = 1
      } else {
        type = 2
      }
      return {
        type, // 1:有斜有正，2：都斜或者都正
        normalArr
      }
    },
    // 判断多选module里面的下划线情况
    judge_text_decoration_line() {
      // 两种情况，有下划线有无下划线（只执行无下划线的），都有下划线或者都无下划线（都执行）
      const underlineArr = []
      const normalArr = []
      let type = null
      this.select_module.forEach(item => {
        const html = $(`#u${item.tid} .my-contenteditable`).html()
        if (html.includes('text-decoration-line:') && html.includes('underline')) {
          underlineArr.push(item.tid)
        } else {
          normalArr.push(item.tid)
        }
      })
      if (underlineArr.length > 0 && normalArr.length > 0) {
        type = 1
      } else {
        type = 2
      }
      return {
        type, // 1:有下划线有无下划线，2：都有下划线或者都无下划线
        normalArr
      }
    },
    // 判断多选module里面的删除线情况
    judge_text_decoration_line_through() {
      // 两种情况，有删除线有无删除线（只执行无删除线的），都有删除线或者都无删除线（都执行）
      const line_throughArr = []
      const normalArr = []
      let type = null
      this.select_module.forEach(item => {
        const html = $(`#u${item.tid} .my-contenteditable`).html()
        if (html.includes('text-decoration-line:') && html.includes('line-through')) {
          line_throughArr.push(item.tid)
        } else {
          normalArr.push(item.tid)
        }
      })
      if (line_throughArr.length > 0 && normalArr.length > 0) {
        type = 1
      } else {
        type = 2
      }
      return {
        type, // 1:有删除线有无删除线，2：都有删除线或者都无删除线
        normalArr
      }
    },
    // 判断多选module里面的横排竖排情况
    judge_text_orientation() {
      // 两种情况，有横排有竖排（只执行竖排的），都横排或者都竖排（都执行）
      const uprightArr = []
      const sidewaysArr = []
      let type = null
      this.select_module.forEach(item => {
        if (item.style['writing-mode'] && item.style['writing-mode'] === 'vertical-lr') {
          uprightArr.push(item.tid)
        } else {
          sidewaysArr.push(item.tid)
        }
      })
      if (uprightArr.length > 0 && sidewaysArr.length > 0) {
        type = 1
      } else {
        type = 2
      }
      return {
        type, // 1:有横排有竖排，2：都横排或者都竖排
        uprightArr,
        sidewaysArr
      }
    },
    fixHeight() {
      this.$nextTick(() => {
        const $el = $(`#u${this.module.tid} .rich-content`)
        if (!$el.length) {
          return
        }
        let innerHeight = $el.height()
        innerHeight = Number(innerHeight.toFixed(0))
        if (this.module.style.height !== innerHeight) {
          this.module.style.height = innerHeight
        }
      })
    },
    rgbToHex(color) {
      const { r, g, b } = this.rgbaToRgb(color)
      var hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
      return hex
    },
    // 传入rgba格式
    rgbaToRgb(color) {
      var rgb = color.split(',')
      var r = parseInt(rgb[0].split('(')[1])
      var g = parseInt(rgb[1])
      var b = parseInt(rgb[2].split(')')[0])
      var a = 1
      if (rgb.length >= 4) {
        a = parseFloat(rgb[3].replace(')', ''))
      }
      return { r, g, b, a }
    },
    /**
     * 判断变量是否一致
     * @param {*} variable 变量名
     * @param {*} value 如果不一致，需要设置的值
     * @param {*} type 类型 style/shadow
     */
    isSame(variable, value, type = 'style') {
      const temp = this.select_module[0][type][variable]
      const isSameTemp = !this.select_module.some(item => {
        return item[type][variable] !== temp
      })
      if (!isSameTemp && variable === 'font-size') {
        const arr = []
        this.select_module.forEach(item => {
          arr.push(item[type][variable])
        })
        // 取字号最大值
        value = Math.max(...arr)
      }
      this.$set(this.module[type], variable, isSameTemp ? temp : value)
    },
    // 返回watcher
    getWatcher(variable, type = 'style') {
      // watch只支持简单点运算，所以需要函数方式
      return this.$watch(
        () => {
          return this.module[type][variable]
        },
        val => {
          this.select_module.forEach(item => {
            item[type][variable] = val
          })
        }
      )
    }
  },
  watch: {
  },
  created() {
    const _module = this.$store.state.widgets.module_Data
    // if(!_module.shadow.hasOwnProperty('isShow')) {
    //   _module.shadow = Object.assign({}, _module.shadow, {
    //     isShow: true
    //   })
    // }
    // if(!_module.hasOwnProperty('stroke')) {
    //   const _stroke = {
    //       'width': 2,
    //       'color': "#000",
    //       'isShow': false
    //   }
    //   _module = Object.assign({}, _module, {
    //     stroke: _stroke
    //   })
    // }
    if (!this.multiple) {
      this.module = _module
      this.color = this.module.style.color
    } else {
      this.module = { style: {}, shadow: {}}
      this.isSame('font-family', '')
      this.isSame('font-size', null)
      this.isSame('text-align', '')
      this.isSame('line-height', 24)
      this.getWatcher('line-height')
      this.isSame('letter-spacing', 0)
      this.getWatcher('letter-spacing')
      this.isSame('color', '#000000')
      this.isSame('background', '#FFFFFF')
      this.getWatcher('background')
      this.isSame('x', null, 'shadow')
      this.getWatcher('x', 'shadow')
      this.isSame('y', null, 'shadow')
      this.getWatcher('y', 'shadow')
      this.isSame('blur', null, 'shadow')
      this.getWatcher('blur', 'shadow')
      this.isSame('color', '#7D7D7D', 'shadow')
      this.getWatcher('color', 'shadow')
      this.isSame('opacity', 1)
      this.getWatcher('opacity')
      this.isSame('rotate', 0)
      this.getWatcher('rotate')
    }
  },
  mounted() {
    var hasPositionNumber = 0
    // 挂件循环，没有职位信息清空职位信息的选项
    this.widgets.forEach(item=> {
      if(item.textType === 'positionInfo') {
        hasPositionNumber++
      }
    })
    if(!hasPositionNumber && this.$route.query.type!='operatingActivities' && this.module === 'positionInfo') {
      this.module.textType = ''
      this.module.positionInfoList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
    font-size: 14px;
    color: #1D2129;
    font-weight: 500;
    line-height: 40px;
}
.position{
    .el-checkbox-group{
        flex-wrap: wrap;
        justify-content: space-between;
        .el-checkbox{
            margin-bottom: 14px;
            width: 50%;
            margin-right: 0;
        }
    }
}
.text-content{
    position: relative;
    .my_color_layer{
        position: absolute;
        left:1px;
        bottom: 1px;
        opacity: 0;
        width: 66px;
        overflow: hidden;
        height: 32px;
    }
}
.flexbox {
    display: flex;
    justify-content: space-between;
    .edit_item_font_size_new{
        width: 90px;
        flex: none!important;
    }
}
.img-bottom {
  margin-left: 0px !important;
}
.line {
  margin-right: 16px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f5f5f5;
}
.edit_frame {
  padding-top: 8px;
  .flexbox {
    align-items: center;
  }
  ::v-deep {
    .shadowItem {
      margin-bottom: 12px;
      .color_box {
        margin-right: 7px;
      }
    }
    .sel_family {
      margin-bottom: 12px;
      .el-select {
        width: 100% !important;
      }
      .el-input__inner {
        font-size: 12px;
        color: #333333;
      }
      .el-input__icon {
        line-height: 24px;
        font-size: 12px;
      }
    }
    .sel_style {
      margin-top: 12px;
      border-radius: 4px;
    }
    .sel_align {
      margin-top: 12px;
      margin-bottom: 12px !important;
      border-radius: 4px;
    }
    .sel_bg {
      .my_edit_item {
        margin-bottom: 12px;
      }
      .color_box {
        width: 60px;
      }
    }
    .sel_powerover {
      position: relative;
      .my_edit_item {
        margin-bottom: 0px;
      }
      .color_box {
        img {
          width: 24px;
          height: 24px;
        }
      }
      .my_color_layer {
        .normal-color-wrapper {
          .title {
            margin-top: 2px;
          }
        }
      }
      > div {
        flex: 1;
      }
    }
    .sel_fshadow {
      margin-bottom: 12px;
    }
  }

  .sel_box {
    position: absolute;
    width: 100%;
    top: 28px;
    left: 0px;
    z-index: 1;
  }

  .right-color {
    flex: 1;
    padding-left: 10px;
  }
  .hideItem {
    margin-bottom: 8px;
  }
  .bottom {
    margin-bottom: 30px;
  }

  .bottom_small {
    margin-bottom: 10px;
  }

  ::v-deep .my_edit_item.color_item {
    display: inline-block;
    width: 50%;
  }
}

.section-title {
  // height: 0;
  // position: relative;
  // border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  margin-top: 10px;

  .section-title-text {
    // position: absolute;
    background: #fff;
    // left: 0;
    padding-right: 10px;
    font-size: 14px;
    line-height: 1;
    // top: -7px;
  }
}

.item-title {
  font-size: 14px;
  margin-bottom: 10px;
}

.my_edit_item {
  flex: 1;
}

::v-deep {
  .el-input-number--medium {
    .el-icon-arrow-down:before {
      content: '\e790';
    }

    .el-icon-arrow-up:before {
      content: '\e78f';
    }

    .el-input__inner {
      padding-top: 4px;
    }

    .el-input-number__decrease,
    .el-input-number__increase {
      color: #5f6c87;
      background-color: transparent;
      border-left: none !important;
      border-bottom: none !important;
    }

    .el-input-number__decrease {
      bottom: 5px !important;
    }

    .el-input-number__increase {
      top: 8px !important;
    }
  }
  .el-input--small .el-input__inner,
  .my-num-symbol {
    height: 24px !important;
    line-height: 24px !important;
  }
  .el-input-number--small {
    line-height: 24px;
  }
}
</style>
<style>
[readonly='readonly'] {
  user-select: none;
}
</style>
